module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image8_2_sub2-35071a5ccc7a5da4bf93837512f87f30.png";